// extracted by mini-css-extract-plugin
export var container = "_35-0";